import Marquee from "react-fast-marquee";

const WORDS = ["Strategy", "Advertising", "Branding", "Social", "Content", "Consulting"];

export default function EditorialMarquee() {
  return (
    <section className="py-10 md:py-16 border-y border-white/10 bg-surface overflow-hidden" data-testid="marquee">
      <Marquee speed={40} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display italic text-6xl md:text-8xl lg:text-[9rem] leading-none px-8 text-stroke">
              {w}
            </span>
            <span className="text-accent text-4xl md:text-6xl px-2">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
